import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import I18n from 'I18n';
import { hasBusinessUnitAccess as hasBusinessUnitAccessFromSelector } from 'FormsUI/selectors/Scope';
import { MANUALLY_EXCLUDED_COLUMNS, PROPERTIES } from 'FormsUI/components/dashboard/frameworkTable/constants';
const usePropertyOverride = () => {
  const hasBusinessUnitAccess = useSelector(hasBusinessUnitAccessFromSelector);
  return useMemo(() => Object.assign({}, MANUALLY_EXCLUDED_COLUMNS.reduce((acc, excludedColumn) => Object.assign({}, acc, {
    [excludedColumn]: {
      hidden: true
    }
  }), []), {
    [PROPERTIES.BUSINESS_UNIT_IDS]: {
      label: I18n.text('dashboard.frameworkTable.columns.businessUnitIds.label'),
      hidden: !hasBusinessUnitAccess,
      description: ''
    },
    [PROPERTIES.CREATED_BY_USER_ID]: {
      label: I18n.text('dashboard.frameworkTable.columns.createdByUserId.label'),
      description: ''
    },
    [PROPERTIES.UPDATED_BY_USER_ID]: {
      label: I18n.text('dashboard.frameworkTable.columns.updatedByUserId.label'),
      description: ''
    },
    [PROPERTIES.CREATED_AT]: {
      label: I18n.text('dashboard.frameworkTable.columns.createdAt.header'),
      description: I18n.text('dashboard.frameworkTable.columns.createdAt.tooltip')
    },
    [PROPERTIES.FORM_ID]: {
      label: I18n.text('dashboard.frameworkTable.columns.appearsOn.header'),
      description: I18n.text('dashboard.frameworkTable.columns.appearsOn.tooltip')
    },
    [PROPERTIES.NAME]: {
      description: ''
    },
    [PROPERTIES.SPAM_SUBMISSIONS]: {
      description: ''
    },
    [PROPERTIES.STATUS]: {
      description: ''
    },
    [PROPERTIES.SUBMISSIONS]: {
      description: ''
    },
    [PROPERTIES.SUBMISSION_RATE]: {
      description: I18n.text('dashboard.frameworkTable.columns.submissionRate.tooltip')
    },
    [PROPERTIES.UPDATED_AT]: {
      description: ''
    },
    [PROPERTIES.VIEWS]: {
      description: I18n.text('dashboard.frameworkTable.columns.views.tooltip')
    }
  }), [hasBusinessUnitAccess]);
};
export default usePropertyOverride;